import { FieldSelection } from "./FieldSelection";
import { PointsSelectionList } from "./PointSelectionList";
import { Section } from "portal/components/map/navigation/Section";
import { t } from "i18next";
import { Zone as ZoneType } from "protos/farm/farm";
import React, { FC } from "react";

interface ZoneSelectionProps {
  zone: ZoneType;
}

export const ZoneSelection: FC<ZoneSelectionProps> = ({ zone }) => {
  const isPath = Boolean(zone.contents?.path);
  const points =
    zone.areas[0]?.lineString?.points ??
    zone.areas[0]?.polygon?.boundary?.points;

  return (
    <div>
      {zone.contents?.field && (
        <FieldSelection fieldData={zone.contents.field} />
      )}
      <Section
        header={
          isPath
            ? t("views.farms.detailsPanel.points")
            : t("views.farms.detailsPanel.boundary")
        }
        isSubsection
        startCollapsed
      >
        {points && <PointsSelectionList points={points} />}
      </Section>
    </div>
  );
};
